<app-pagetoolbar icon="cancel" label="Combinations"> </app-pagetoolbar>
<mat-card class="fab-panel" ngClass.xs="fab-panel-xs">
  <div class="filter-container">
    <mat-button-toggle-group [value]="selectedFilter" (change)="onFilterChange($event.value)" aria-label="Filter combinations">
      <mat-button-toggle value="current">Current</mat-button-toggle>
      <mat-button-toggle value="historical">Historical</mat-button-toggle>
      <mat-button-toggle value="all">All</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <button mat-fab color="accent" id="new-crossmatch" type="button" (click)="openAddDialog()" *ngIf="addCrossmatches">
    <mat-icon>add</mat-icon>
  </button>

  <mat-tab-group>
    <mat-tab label="Excluded Combinations">
      <app-excluded-list [excludedCombinations]="filteredExcludedCombinations" [totalRows]="ecCount"> </app-excluded-list>
    </mat-tab>
  </mat-tab-group>
</mat-card>
